import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFetchMediaPath } from '../../queries';
import '../SharedComponents/Weather/Previews/Corner/css/CornerWeatherPreview.css';

const IframePlayer = () => {
    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');
    const id = query.get('id');

    const payload = { token, id };
    const { data, isLoading, isError } = useFetchMediaPath(payload);

    useEffect(() => {
        document.body.classList.add('transparent-body');
        return () => {
            document.body.classList.remove('transparent-body');
        };
    }, []);

    if (!token || !id) {
        return <div style={{ padding: '2rem', color: 'red', background: 'transparent', }}>Missing token or id in URL</div>;
    }

    if (isLoading) {
        return <div style={{ padding: '2rem', background: 'transparent', }}>Loading...</div>;
    }

    if (isError || !data?.data) {
        return <div style={{ padding: '2rem', color: 'red', background: 'transparent', }}>Error loading media path</div>;
    }

    const iframeSrc = `${data.data}?token=${encodeURIComponent(token)}&id=${encodeURIComponent(id)}`;

    return (
        <iframe
            src={iframeSrc}
            onLoad={(e) => {
                e.target.style.background = 'transparent';
            }}
            frameBorder="0"
            allowTransparency={true}
            style={{
                width: '100vw',
                height: '100vh',
                background: 'transparent',
                border: 'none',
            }}
        />
    );
};

export default IframePlayer;
